import { Block } from 'factories/block';
import { State } from 'store/store';

// export function transformListFromIdToSId(blocks, list: string[]): number[] {
//   const transformedList = list.map(id => {
//     const { sId } = blocks[id]?.props;
//     //
//     // we might want to save the original id if there's not an sId on the block ?

//     return sId;
//   });

//   return transformedList || (list as any);
// }

// export function transformListFromSIdToId(blocks, list: number[]): string[] {
//   const transformedList = list.map(sId => {
//     const block = Object.values(blocks).find(b => {
//       // based on the above
//       // if we don't have an sId on this block. for whatever reason. we've saved the id
//       // and we run some logic to load that back
//       return (b as Block)?.props?.sId === sId;
//     }) as Block;

//     return block?.id || block?.props?.id;
//   });

//   return transformedList;
// }

export function transformListFromIdToSId(idToSIdMap, list: string[]): number[] {
  const transformedList = list.map(id => {
    return idToSIdMap[id];
  });

  return transformedList || (list as any);
}

export function transformListFromSIdToId(sIdToIdMap, list: number[]): string[] {
  const transformedList = list.map(sId => {
    return sIdToIdMap[sId];
  });

  return transformedList;
}
